import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./CharactersSection.module.scss";

const CharactersSection = ({
  character1Name,
  character1Age,
  character1About,
  character2Name,
  character2Age,
  character2About,
  character3Name,
  character3Age,
  character3About,
}) => {
  return (
    <div className={cs(classes.container)}>
      {/* Main Question Header */}


      {/* Character 1 Box - Top rounded corners */}
      <div className={cs(classes.characterBox, classes.topBox, { 
        [classes.error]: (character1Name.error && character1Name.touched) || 
                        (character1Age.error && character1Age.touched) || 
                        (character1About.error && character1About.touched) 
      })}>
        <label className={cs(classes.mainLabel)}>
          Who are the main 3 characters?{" "}
          <span className={cs(classes.required)}>*</span>
        </label>
        <div className={cs(classes.characterGroup, "mt-04")}>
          <div className={cs(classes.characterRow)}>
            <h3 className={cs(classes.characterTitle)}>Character 1:</h3>

            <div className={cs(classes.inputField)}>
              <label htmlFor="char1-name" className={cs(classes.fieldLabel)}>
                Name:
              </label>
              <div className={cs(classes.inputWrapper)}>
                <input
                  id="char1-name"
                  type="text"
                  className={cs(classes.input)}
                  value={character1Name.value}
                  onChange={character1Name.onChange}
                  placeholder="Short Answer text"
                />
                <div className={cs(classes.underline)} />
              </div>
            </div>
            <div className={cs(classes.inputField)}>
              <label htmlFor="char1-age" className={cs(classes.fieldLabel)}>
                Age:
              </label>
              <div className={cs(classes.inputWrapper)}>
                <input
                  id="char1-age"
                  type="text"
                  className={cs(classes.input)}
                  value={character1Age.value}
                  onChange={character1Age.onChange}
                  placeholder="Short Answer text"
                />
                <div className={cs(classes.underline)} />
              </div>
            </div>
          </div>
          <div className={cs(classes.inputField, classes.fullWidth)}>
            <label htmlFor="char1-about" className={cs(classes.fieldLabel)}>
              About this character:
            </label>
            <div className={cs(classes.inputWrapper)}>
              <input
                id="char1-about"
                type="text"
                className={cs(classes.input)}
                value={character1About.value}
                onChange={character1About.onChange}
                placeholder="Short Answer text"
              />
              <div className={cs(classes.underline)} />
            </div>
          </div>
        </div>
      </div>

      {/* Character 2 Box - No rounded corners */}
      <div className={cs(classes.characterBox, classes.middleBox, { 
        [classes.error]: (character2Name.error && character2Name.touched) || 
                        (character2Age.error && character2Age.touched) || 
                        (character2About.error && character2About.touched) 
      })}>
        <div className={cs(classes.characterGroup)}>
          <div className={cs(classes.characterRow)}>
            <h3 className={cs(classes.characterTitle)}>Character 2:</h3>
            <div className={cs(classes.inputField)}>
              <label htmlFor="char2-name" className={cs(classes.fieldLabel)}>
                Name:
              </label>
              <div className={cs(classes.inputWrapper)}>
                <input
                  id="char2-name"
                  type="text"
                  className={cs(classes.input)}
                  value={character2Name.value}
                  onChange={character2Name.onChange}
                  placeholder="Short Answer text"
                />
                <div className={cs(classes.underline)} />
              </div>
            </div>
            <div className={cs(classes.inputField)}>
              <label htmlFor="char2-age" className={cs(classes.fieldLabel)}>
                Age:
              </label>
              <div className={cs(classes.inputWrapper)}>
                <input
                  id="char2-age"
                  type="text"
                  className={cs(classes.input)}
                  value={character2Age.value}
                  onChange={character2Age.onChange}
                  placeholder="Short Answer text"
                />
                <div className={cs(classes.underline)} />
              </div>
            </div>
          </div>
          <div className={cs(classes.inputField, classes.fullWidth)}>
            <label htmlFor="char2-about" className={cs(classes.fieldLabel)}>
              About this character:
            </label>
            <div className={cs(classes.inputWrapper)}>
              <input
                id="char2-about"
                type="text"
                className={cs(classes.input)}
                value={character2About.value}
                onChange={character2About.onChange}
                placeholder="Short Answer text"
              />
              <div className={cs(classes.underline)} />
            </div>
          </div>
        </div>
      </div>

      {/* Character 3 Box - Bottom rounded corners */}
      <div className={cs(classes.characterBox, classes.bottomBox, { 
        [classes.error]: (character3Name.error && character3Name.touched) || 
                        (character3Age.error && character3Age.touched) || 
                        (character3About.error && character3About.touched) 
      })}>
        <div className={cs(classes.characterGroup)}>
          <div className={cs(classes.characterRow)}>
            <h3 className={cs(classes.characterTitle)}>Character 3:</h3>
            <div className={cs(classes.inputField)}>
              <label htmlFor="char3-name" className={cs(classes.fieldLabel)}>
                Name:
              </label>
              <div className={cs(classes.inputWrapper)}>
                <input
                  id="char3-name"
                  type="text"
                  className={cs(classes.input)}
                  value={character3Name.value}
                  onChange={character3Name.onChange}
                  placeholder="Short Answer text"
                />
                <div className={cs(classes.underline)} />
              </div>
            </div>
            <div className={cs(classes.inputField)}>
              <label htmlFor="char3-age" className={cs(classes.fieldLabel)}>
                Age:
              </label>
              <div className={cs(classes.inputWrapper)}>
                <input
                  id="char3-age"
                  type="text"
                  className={cs(classes.input)}
                  value={character3Age.value}
                  onChange={character3Age.onChange}
                  placeholder="Short Answer text"
                />
                <div className={cs(classes.underline)} />
              </div>
            </div>
          </div>
          <div className={cs(classes.inputField, classes.fullWidth)}>
            <label htmlFor="char3-about" className={cs(classes.fieldLabel)}>
              About this character:
            </label>
            <div className={cs(classes.inputWrapper)}>
              <input
                id="char3-about"
                type="text"
                className={cs(classes.input)}
                value={character3About.value}
                onChange={character3About.onChange}
                placeholder="Short Answer text"
              />
              <div className={cs(classes.underline)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const inputPropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
});

CharactersSection.propTypes = {
  character1Name: inputPropTypes.isRequired,
  character1Age: inputPropTypes.isRequired,
  character1About: inputPropTypes.isRequired,
  character2Name: inputPropTypes.isRequired,
  character2Age: inputPropTypes.isRequired,
  character2About: inputPropTypes.isRequired,
  character3Name: inputPropTypes.isRequired,
  character3Age: inputPropTypes.isRequired,
  character3About: inputPropTypes.isRequired,
};

export default CharactersSection;